import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface IListStateIconRiskProps {
  noMargin?: boolean;
  tooltip?: string;
  color?: string;
  customColor?: string;
}

export const ListStateIconRisk = ({
    noMargin,
    tooltip,
    color,
    customColor,
}: IListStateIconRiskProps) => (
    <ListStateIcon
        color={color}
        customColor={customColor}
        noMargin={noMargin}
        tooltip={tooltip}
        icon={WarningAmberIcon}
    />
);
